import React, { useState } from "react";
import mastercourseapi from '../api/mastercourse';
import loginapi from '../api/login';

const Course = ({ course,slno,accessToken,setAccessToken,setRefreshFailed }) => {
  const [midTermTotal, setMidTermTotal] = useState(course.midTermTotal);
  const [endTermTotal, setEndTermTotal] = useState(course.endTermTotal);
  const [practicalTotal, setPracticalTotal] = useState(course.practicalTotal);
  const [title, setTitle] = useState(course.title);
  const [isUpdating, setIsUpdating] = useState(false);

  // Update function to simulate saving the data to the database
  const handleUpdate = async () => {
    setIsUpdating(true);

     try{       
            //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
            const response=await mastercourseapi.post('/updateTotalMarks',{code:course.code,midTermTotal,endTermTotal,practicalTotal,title},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
            //alert(JSON.stringify(response.data));
            //setCourses(response.data);
            //alert(response.data);
            }
            catch(err)
            {
              try{
                const config = { withCredentials: true };
                const x=await loginapi.get('/getAccessToken',config);            
                const nat=x['data']['accessToken'];
                const lt=x['data']['loginType'];
                //alert(nat);
                setAccessToken(nat);
                setRefreshFailed(false);  
                        
               
                  if(lt.toLowerCase()==="admin")
                    {
                          try{       
                            //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                            const response=await mastercourseapi.post('/updateTotalMarks',{code:course.code,midTermTotal,endTermTotal,practicalTotal,title},{headers:{'Authorization':`Bearer ${nat}`}});                            
                            //alert(JSON.stringify(response.data));
                            //setCourses(response.data);
                            //alert(response.data);
                        }
                        catch(err)
                        {
                          //alert('refresh failed unusual'+JSON.stringify(err));
                          setAccessToken('');
                          setRefreshFailed(true);  
                        }
                      }
                }
                catch(err)
                {
                  //alert('dd');
                  setAccessToken(''); 
                  setRefreshFailed(true);              
                }
            }         
             finally
                {
                    setIsUpdating(false);
                  //alert('app loaded'+accessToken);
                }
  };

  return (
    <div className="max-w-5xl mx-auto my-4 p-4 bg-white shadow-lg rounded-lg border border-gray-200">
      <div className="w-full flex items-center justify-center">
        <span className="text-lg font-semibold text-blue-700">{slno}</span>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="flex-1 border-b border-gray-300 focus:outline-none focus:border-blue-500 px-1  ml-2 mb-2"
        />
      </div>

      {/* Responsive Layout */}
      <div className="grid grid-cols-1 sm:grid-cols-6 gap-6 items-center">
        {/* Course Code */}
        <div className="sm:col-span-1">
          <p className="text-sm text-gray-600">Course Code:</p>
          <p className="text-base text-gray-900 font-medium">{course.code}</p>
        </div>

        {/* Credits */}
        <div className="sm:col-span-1">
          <p className="text-sm text-gray-600">Credits:</p>
          <p className="text-base text-gray-900 font-medium">{course.credit}</p>
        </div>

        {/* Mid Term Total */}
        <div className="sm:col-span-1">
          <p className="text-sm text-gray-600">Mid Term Total:</p>
          <input
            type="number"
            className="w-full mt-1 px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
            value={midTermTotal||0}
            onChange={(e) => setMidTermTotal(e.target.value)}
          />
        </div>

        
        {/* Practical Total */}
        <div className="sm:col-span-1">
          <p className="text-sm text-gray-600">End Practical Total:</p>
          <input
            type="number"
            className="w-full mt-1 px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
            value={practicalTotal||0}
            onChange={(e) => setPracticalTotal(e.target.value)}
          />
        </div>


        {/* End Term Total */}
        <div className="sm:col-span-1">
          <p className="text-sm text-gray-600">End Theory Total:</p>
          <input
            type="number"
            className="w-full mt-1 px-3 py-2 border rounded-md focus:outline-none focus:ring focus:ring-indigo-300"
            value={endTermTotal||0}
            onChange={(e) => setEndTermTotal(e.target.value)}
          />
        </div>

        {/* Update Button */}
        <div className="sm:col-span-1 flex justify-end mt-4 lg:mt-0">
          <button
            onClick={handleUpdate}
            disabled={isUpdating}
            className={`w-full sm:w-auto px-4 py-2 text-white rounded-md ${
              isUpdating
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-indigo-600 hover:bg-indigo-500"
            }`}
          >
            {isUpdating ? "Updating..." : "Update"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Course;
